import { memo, useCallback, useEffect, useState } from 'react';
import { BzChip, BzInputText, BzModal, BzModalBody, BzModalHeader, } from "../../components";
import { Container, Row, Col } from "react-bootstrap";
import { TabsScripsList } from '../Search';
import { useDispatch, useSelector } from 'react-redux';
import { getSearchScrips } from '../../redux/actions/globalSearch';
import { GLOBAL_SEARCH_MIN_LENGTH, MAX_SEARCH_SCRIP_PER_PAGE, ORDER_ENTRY_BUTTON_TOGGLE, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { useDebounce } from '../../hooks';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { toastConfig } from '../../redux/actions/toast';
import { addNewWatchlist, getColumnDef } from '../../redux/actions/watchlist';
import { _createAndAddScripsInWatchlist } from '../../controllers';
import { isUserIsAGuest, ORDER_ENTRY_GRID_REF, getApiExchangeNameFromMktSegId, getMappedMktSegIdFromApiExchangeName, returnCountWithPad, getscripCountPerWatchlist, isGuestUser } from '../../utils/global_functions';
import { getExchangeWiseScripInfo, getScripOrderInfo, getSpreadOrder, updateIsBuyOrSell } from '../../redux/actions/orders';




const ScripsRecommendationsModal = ({ setBIsEmptyWatchlistView, createdWatchlistName, setCreatedWatchlistName, customNewWatchlistName, watchlists, isWatchlistPresent, ...props }) => {
    const modals = useSelector(state => state?.modals?.modals);
    const userId = useSelector(state => state?.auth?.userId);
    const { appInfo } = useSelector(state => state.appInfo);
    const recommendations = useSelector(state => state.recommendation.recommendations);
    const arrHotPursuitData = useSelector(state => state?.news?.arrHotPursuitData);



    const [scripsSearchValue, setScripsSearchValue] = useState('');
    const [scripsToBeAdded, setScripsToBeAdded] = useState([]);
    const [arrRecommendationScrips, setArrRecommendationScrips] = useState([]);
    useEffect(() => {
        if (recommendations?.length) {
            const arrRecommendations = {};
            const recommedationScrip = recommendations.filter((each) => {
                const objKey = each['companyName'];
                if (!arrRecommendations.hasOwnProperty(objKey)) {
                    arrRecommendations[objKey] = true;
                    return true;
                }
                return false;
            });
            setArrRecommendationScrips(recommedationScrip);
        }
    }, [recommendations]);

    const dispatch = useDispatch();

    const onAddCustomNewWatchlist = useCallback((scripsToBeAdded = [], customNewWatchlistName) => {
        let scripsAllowedPerWatchlist = getscripCountPerWatchlist()
        let handleCreateAndAddingScrips = _createAndAddScripsInWatchlist(watchlists, scripsToBeAdded, customNewWatchlistName, isWatchlistPresent, scripsAllowedPerWatchlist, userId);


        if (!handleCreateAndAddingScrips.status) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: handleCreateAndAddingScrips.message }));
        } else {
            dispatch(addNewWatchlist(handleCreateAndAddingScrips?.data?.objWatchlistPayload))?.then(() => {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `${handleCreateAndAddingScrips?.data?.objWatchlistPayload?.sWatchListName} (${returnCountWithPad(handleCreateAndAddingScrips?.data?.objWatchlistPayload?.scrips?.length)}) successfully added to your  watchlist` }));
                if(isGuestUser()){
                    dispatch(getColumnDef())
                }
            });
            dispatch(handleModal([{ "SCRIPT_RECOMMENDATIONS_MODAL": false }]));
            setScripsToBeAdded([]);
            setScripsSearchValue('');
            setCreatedWatchlistName('');
            setBIsEmptyWatchlistView(false);
        }


    }, [userId, watchlists, appInfo, setBIsEmptyWatchlistView, dispatch, setCreatedWatchlistName, isWatchlistPresent]);

    const onAddingScripsToNewWatchlist = (e) => {
        setScripsSearchValue(e.target.value);
        if (e.target.value.length >= GLOBAL_SEARCH_MIN_LENGTH) {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useDebounce(() => {
                dispatch(getSearchScrips(e.target.value, -1, 0, MAX_SEARCH_SCRIP_PER_PAGE, true));
            }, 1000);
        } else { }
    };

    const handleAddScripsFromSearch = (e, scrip) => {
        setScripsToBeAdded(curr => [...curr, scrip]);
    };

    const handleRemoveScripsFromSearch = (e, scripToBeRemoved) => {

        // e.stopPropogation();
        if (scripsToBeAdded && scripsToBeAdded.length > 0) {
            const arrScripsToBeAdded = scripsToBeAdded;
            const nIndex = arrScripsToBeAdded.findIndex(element => element[0] === scripToBeRemoved[0]);
            if (nIndex >= 0) {
                arrScripsToBeAdded.splice(nIndex, 1);
                setScripsToBeAdded([...arrScripsToBeAdded]);
            }
        }
    };



    //Ameersha N : 22-11-2023 : BT-95888 - Breeze - Create Watchlist - Start
    const handleDoneOnClick = useCallback(() => {
        if (scripsToBeAdded?.length > 0) {
            onAddCustomNewWatchlist(scripsToBeAdded, customNewWatchlistName);
            dispatch(handleModal([{ "SCRIPT_RECOMMENDATIONS_MODAL": false }]));
            setScripsToBeAdded([]);
            setScripsSearchValue('');
            setCreatedWatchlistName('');
        } else {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: 'Atleast one scrip should be added' }));
        }
    }, [scripsToBeAdded, dispatch, setCreatedWatchlistName, onAddCustomNewWatchlist, customNewWatchlistName]);
    //Ameersha N : 22-11-2023 : BT-95888 - Breeze - Create Watchlist - End

    const onHide = () => {
        setScripsToBeAdded([]);
        setScripsSearchValue('');
        setCreatedWatchlistName('');
        dispatch(handleModal([{ "SCRIPT_RECOMMENDATIONS_MODAL": false }]));
    };

    const onBack = () => {
        dispatch(handleModal([{ "SCRIPT_RECOMMENDATIONS_MODAL": false }, { 'CREATE_WATCHLIST_MODAL': true }]));
        setScripsSearchValue('');
    };

    const onClose = () => {
        dispatch(handleModal([{ "SCRIPT_RECOMMENDATIONS_MODAL": false }]));
        setScripsSearchValue('');
        setCreatedWatchlistName('');
    };


    //Ameersha N - 12-12-2023 - BT-95888 - Breeze- Create Watchlist - Start
    const handleTrendOrRecoClikc = (companyName) => {
        const strGlobalSearchText = companyName?.toUpperCase();
        setScripsSearchValue(strGlobalSearchText);
        if (companyName.length >= GLOBAL_SEARCH_MIN_LENGTH) {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useDebounce(() => {
                dispatch(getSearchScrips(companyName, -1, 0, MAX_SEARCH_SCRIP_PER_PAGE, true));
            }, 1000);
        } else { }
    };
    //Ameersha N - 12-12-2023 - BT-95888 - Breeze- Create Watchlist - End



    // Ameersha N : 27-02-2024 : BT-95888 : Create Watchlist- Start
    const handleSelectSpreadOrderModel = (spreadArr, strBuySell) => {
        dispatch(updateIsBuyOrSell(strBuySell));//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry 
        var spreadPaylod =
        {
            "mktSegid": getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(spreadArr[WATCHLIST_GRID_INDEX.SEGMENT_ID])),//Ameersha N - 04-03-2024 - Sending Mapped Market Segment ID for spread API
            "symbol": spreadArr[WATCHLIST_GRID_INDEX.SYMBOL],
            "token": spreadArr[WATCHLIST_GRID_INDEX.TOKEN]
        };
        dispatch(getSpreadOrder(spreadPaylod));
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }, true]));
        const objScrpinfo = { activeExchangeId: '', isBuySell: 0, scripData: spreadArr };
        dispatch(getScripOrderInfo(objScrpinfo));
        dispatch(handleModalData({ data: { spreadArr: spreadArr, orderEntryTab: 'multi_scrip', activeTabKey: 'spread' } }), true);

    };

    // Ameersha N : 27-02-2024 : BT-95888 : Create Watchlist- Start
    const handlePlaceOrder = useCallback((orderInfo, nIsBuyOrSell) => {
        ORDER_ENTRY_GRID_REF.current.setIsScripPrice(false);
        dispatch(getScripOrderInfo({ isBuySell: nIsBuyOrSell, activeExchangeId: orderInfo[WATCHLIST_GRID_INDEX.EXCHANGE], scripData: orderInfo }));
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }]));
    }, [dispatch]);
    // Ameersha N : 27-02-2024 : BT-95888 : Create Watchlist- End


    // Ameersha N : 07-11-2023 : BT-95888 create watchlist [local search feature] – Issue - addedScrips state not getting empty  – Start
    // Ameersha N : 27-02-2024 : BT-95888 : Create Watchlist- Start
    const onBuySellClick = useCallback((strBuySell, arrRowData) => {
        if (!isUserIsAGuest('buy_sell')) {//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
            if (arrRowData[WATCHLIST_GRID_INDEX?.NSPREAD] === 1) {
                handleSelectSpreadOrderModel(arrRowData, strBuySell);

            } else {
                handlePlaceOrder(arrRowData, strBuySell.toUpperCase() === 'BUY' ? ORDER_ENTRY_BUTTON_TOGGLE.BUY : ORDER_ENTRY_BUTTON_TOGGLE.SELL);
                dispatch(getExchangeWiseScripInfo(arrRowData));
            }

            onHide();

        } else { }//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End

    }, [handlePlaceOrder, handleSelectSpreadOrderModel, dispatch, setScripsSearchValue]);
    // Ameersha N : 27-02-2024 : BT-95888 : Create Watchlist- End
    // Ameersha N : 07-11-2023 : BT-95888 create watchlist [local search feature] – Issue - addedScrips state not getting empty  – End

    // Ameersha N : 27-02-2024 : BT-95888 : Create Watchlist- End

    return (
        <BzModal show={modals['SCRIPT_RECOMMENDATIONS_MODAL']} onHide={onHide} className='modal-breeze recommendations-modal'>
            <BzModalHeader className='p-0'>
                <Container fluid className='p-3 bdr-btm'>
                    <Row className='g-0 align-items-center'>
                        <Col md={1}>
                            <div className='icon-16 icon-backward-arrow icon-dark' onClick={onBack}></div>
                        </Col>
                        <Col className='no-focus-textbox'>
                            <BzInputText className='form-control font-regular color-text bdr-none scripname-searchtext' value={scripsSearchValue} onChange={onAddingScripsToNewWatchlist} type="input" placeholder="Search scrip" />
                        </Col>
                        {scripsSearchValue?.length >= 3 ?
                            <Col md={1}><span className='font-medium color-text ms-2' onClick={() => { setScripsSearchValue(''); }}>Clear</span></Col>
                            : null}
                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={onClose}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody className='p-0'>
                {scripsSearchValue && scripsSearchValue?.length >= GLOBAL_SEARCH_MIN_LENGTH ?
                    <TabsScripsList isKeyboard={false} onBuySellClick={onBuySellClick} isDefaultAllTab={true} strWatchlistName={createdWatchlistName} scripDetails={scripsToBeAdded} isSearchScrips={true} strSearchInputText={scripsSearchValue}
                        addScrips={handleAddScripsFromSearch} removeScrips={handleRemoveScripsFromSearch} onHandleDone={handleDoneOnClick} />
                    :
                    <Container fluid className='p-3'>
                        <div className='py-3'>
                            <Row className='g-0 mb-3'>
                                <Col className='d-flex align-items-center'>
                                    <div className='icon-16 icon-recommendations-fill icon-dark me-2'></div>
                                    <div className='font-medium font-size2 color-text'>Recommendations</div>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col>
                                    <div className='chips-wrap'>
                                        {arrRecommendationScrips.map((each) => (
                                            <BzChip className='multi-chip mb-3 me-3' key={each.id} onClick={() => handleTrendOrRecoClikc(each.companyName)}>{each.companyName}</BzChip>
                                        ))}
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className='py-3'>
                            {arrHotPursuitData?.length > 0 && <>
                                <Row className='g-0 mb-3'>
                                    <Col className='d-flex align-items-center'>
                                        <div className='icon-16 icon-trending icon-dark me-3'></div>
                                        <div className='font-medium font-size2 color-text'>Trending</div>
                                    </Col>
                                </Row>
                                <Row className='g-0'>
                                    <Col>
                                        <div className='chips-wrap'>
                                            {arrHotPursuitData.map((each) => (
                                                <BzChip className='multi-chip mb-3 me-3' key={each.id} onClick={() => handleTrendOrRecoClikc(each?.symbol)}>{each?.symbol}</BzChip>
                                            ))}
                                        </div>
                                    </Col>
                                </Row>
                            </>}
                        </div>
                    </Container>
                }
            </BzModalBody>
        </BzModal>
    );
};

export default memo(ScripsRecommendationsModal);